<template>
    <div class="background" id="interact">
        <div class="main">
            <div class="row">
                <h2 slot="title" class="message"><span v-html="message ? message : 'Join the Raffle' "></span><span v-if="message=='Trying to escape from the limbo.'"><img alt="limbo ghost" class="icon" src="../assets/icons/icons8-ghost-64.png"><br/><br/>Please wait ...</span></h2>
            </div>
            <button v-if="tx_hash" v-on:click="open_tx" type="button" class="btn-danger red-red btn join-button margin-top" onclick="this.blur();">  
                View on Etherscan
            </button>
            <button  v-if="(!tx_hash && !web3) || return_btn || (mustPickWinner && MPWP==false && mustsyncWF==false) ||mustAprrove ||mustload"  v-on:click="load_wallet_approve_return_winner" type="button" v-bind:class="button_class ? button_class : 'btn-danger red-red '" class="btn join-button margin-top" onclick="this.blur();">
                <span style="flex-grow:0;">{{ button_message ? button_message : "Connect to Ethereum wallet" }}</span>
            </button>
            <div v-if="web3 && !tx_hash && ready" class="my-row">

                <div class="tokenrow token_text">
                    <button type="button" v-on:click="set_token('SHUF')" v-bind:class="buywith === 'SHUF' ? 'btn-danger red-red' : 'btn-secondary'" class="btn token-button">SHUF</button>
                    <button type="button" v-on:click="set_token('ETH')" v-bind:class="buywith === 'ETH' ? 'btn-danger red-red' : 'btn-secondary'" class="btn token-button">ETH</button>
                   <!-- <button type="button" v-on:click="set_token('ERC20')" v-bind:class="buywith !=='SHUF' && buywith !=='ETH'  ? 'btn-danger red-red' : 'btn-secondary'" class="btn token-button">ERC20</button> -->
                    <multiselect  @input="set_token('ERC20')" class="erc20button" v-model="ERC20" track-by="symbol" label="symbol"  placeholder="ERC20" :maxHeight=300 :options="options" :show-labels="false" :allow-empty="false" ></multiselect>
                    
                </div>

                <span class="ticketbox">
                    <div class="flex12 store_text">
                        <div class="flex22 flex221">Address:</div><div class="flex22 flex222">{{ shortAddressR(address) ? shortAddressR(address) : "0x000. . .00000" }}</div>  
                        <div class="flex22 flex221">Wallet balance:</div><div class="flex22 flex222">{{ wallet_balance ? wallet_balance : "0" }} {{buywith!='ERC20'? buywith:ERC20.symbol}}</div>
                    </div>
                    <div class="flex12 store_text">
                        <div class="flex22 flex221">Tickets owned:</div><div class="flex22 flex222">{{ ticketsowned ? ticketsowned : ". . ." }}</div>
                        <div class="flex22 flex221">Chances to win:</div><div class="flex22 flex222">{{ !isNaN(chances) ? chances : ". . ." }}%</div>
                     </div>
                </span>
                <div class="flex11 store_text buy_text"><div style="width:85px;text-align:right;">Grab</div><input @click="$event.target.select()" class="form-control input_align_child" id="inputAmount" placeholder="" v-model.number="amnt" type="number" v-on:input="on_set_amnt"><div style="width:85px;text-align:left">{{ amnt>1 ? "tickets" : "ticket" }}</div></div>
                <div class="flex11 store_text mini_text" >Total cost: {{ totalcost ? totalcost : ". . ." }} {{buywith!='ERC20'? buywith:ERC20.symbol}} ({{ ticketcost ? ticketcost : ". . ." }} SHUF/ticket)</div>
                <div class="flex11">
                    <button type="button" v-on:click="buytickets" v-bind:class="ready === false ? 'btn-secondary' : 'btn-danger red-red'" class="btn join-button">
                        {{ buy_button_message ? buy_button_message : "Buy now" }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getWeb3,readWeb32socket,readWeb32, getTokenContract, geterc20contract, getRaffleDapp, getunishuf, getunitoken } from '../web3.js';

import promisify from '../utils/promisify.js';
import Multiselect from 'vue-multiselect'
import optionsimp from '../utils/erc20tokens.json';
import BigNumber from "../utils/bignumber.mjs"



export default {
    name: 'Interact',
     components: { Multiselect },
    data: function(){
        return {
            button_class: this.button_class,
            button_message: this.button_message,
            address: this.address,
            message: this.message,
            ready: this.ready,
            balance: this.balance,
            signature: this.signature,
            web3: this.web3,
            tx_hash: this.tx_hash,
            
            ticketsowned: this.ticketsowned,  
            totaltickets: this.totaltickets,
            chances: this.chances,         

            ticketcost: this.ticketcost,
            pickerreward:this.pickerreward,           
            mustPickWinner: this.mustPickWinner,   

            wallet_balance:this.wallet_balance,  
            mustAprrove: this.mustApprove,
            amnt: this.amnt,
            totalcost: this.totalcost,
            loaded:this.loaded,
            lastState:this.lastState,
            return_btn:this.return_btn,
            MPWP:this.MPWP,
            mustload:this.mustload,
            ERC20:this.ERC20,
            buywith:this.buywith,
            options: optionsimp.sort(compare),
            mustApproveErc20:this.mustApproveErc20,
            buy_button_message: this.buy_button_message,
            preserve:this.preserve
    
        };
    },

    created: async function() {
        this.MPWP = false;
        this.message = "Join the Raffle";
        this.last_win_block=0;
        this.last_tic_block=0;
        this.last_closed=0;
        this.raffleClosed =false;
        this.mustload=true;
        this.mustsyncWF=false;
        this.buywith="SHUF";
        this.ERC20 = null;
        this.mustApproveErc20=true;

        this.RaffleDapp = getRaffleDapp(readWeb32socket());
        this.unishuf = getunishuf(readWeb32())

    },

    mounted() {
        this.load_wallet();
        
        this.$root.$on('timesup', ()=> {
            if(this.mustPickWinner==false && this.loaded==true){
                this.message="Trying to escape from the limbo."
                this.return_btn=false;
                this.tx_hash=false;
                this.ready=false;
                this.limbo();
            }
        }),

        this.$root.$on('totaltickets', data=> {
            this.totaltickets=data;
            this.find_chances();
        }),

        this.$root.$on('winner_stats', data => {
            if(data.blockNumber != this.last_win_block){
                let wonamount = parseFloat(data.returnValues.amount.toString())
                //wonamount=wonamount-(wonamount*this.preserve/100)
                this.message=`${shortAddress(data.returnValues.addr)} WINS ${formatAmount(wonamount / 10 ** 18)} SHUF!`;
                this.tx_hash = data.transactionHash;
                this.button_message="Return"; 
                this.mustload=false;
                this.ready=false;
                this.MPWP = false;
                this.return_btn=true;
                this.mustsyncWF=true;
                this.last_win_block=data.blockNumber;            
            }
        })  
    },

    methods:{

        // openDropdown() {
        //     console.log('open');
        //     this.$refs.ddown.visible = true
        //     console.log(this.$refs.ddown)
        //     // $('#ddown1').dropdown('toggle');
        // },
      

        toggle() {
            this.autoselectMenu = !this.autoselectMenu
        },
  
        subscribe_winner:async function() {          
            this.RaffleDapp.once('Winner', {fromBlock: this.web3.eth.blockNumber},  function(error, event){
                if (error) {
                    console.log(error);
                } else { 
                    if(event.blockNumber != this.last_win_block){
                        this.$root.$emit('winner_interact', event);
                        let wonamount = parseFloat(event.returnValues.amount.toString())
                        wonamount=wonamount-(wonamount*this.preserve/100)
                        this.message=`${shortAddress(event.returnValues.addr)} WINS ${formatAmount(wonamount / 10 ** 18)} SHUF!`;
                        this.tx_hash = event.transactionHash;
                        this.button_message="Return"; 
                        this.mustload=false;
                        this.ready=false;
                        this.MPWP = false;
                        this.mustPickWinner=false;
                        this.return_btn=true;
                        this.last_win_block=event.blockNumber;
                    }
                }
            }.bind(this));      
        },

         subscribe_closed:async function() {          
            this.RaffleDapp.once('RaffleClosed', {fromBlock: this.web3.eth.blockNumber},  function(error, event){
                if (error) {
                    console.log(error);
                } else { 
                    if(event.blockNumber != this.last_closed){
                        this.$root.$emit('raffle_closed_interact', event);
                        this.message=`Get rewarded ${this.pickerreward} SHUF to pick the winner!`;
                        this.button_message="Pick the Winner"
                        this.raffleClosed=true;
                        this.tx_hash=false;
                        this.MPWP = false;
                        this.last_closed=event.blockNumber;
                    }
                }
            }.bind(this));      
        },
        
        account_changed:async function(event){
            const ev1 = await event.selectedAddress;
            const ev2 = await this.lastState;
            if (this.loaded==true && ev1 !== ev2) {
                window.web3.currentProvider.publicConfigStore.off('update', this.account_changed);    
                this.load_wallet();
            }
        },

        open_tx: function() {
            var redirectWindow = window.open(`https://etherscan.io/tx/${this.tx_hash}`, '_blank');
            redirectWindow.location;
        },

        set_token: function(token) {
           if(token=='SHUF'){
               this.buy_button_message="Buy now";
              this.buywith = 'SHUF'
               this.ERC20 = null
               this.find_total()
               this.get_wallet_balance();
               
           }
           else if(token=='ETH'){
               this.buy_button_message="Buy now";
               this.buywith = 'ETH'
               this.ERC20 = null
               this.find_total()
               this.get_wallet_balance();
           }
           else{
               this.buy_button_message="Approve";
               this.mustApproveErc20=true;     
               this.buywith = 'ERC20'
               this.find_total()
               this.get_wallet_balance();

           }
        },


        


        buytickets: async function() {
            if (!this.ready) {
                return;
            }
                await this.load_price_mustPickWinner(); 
                if(this.mustPickWinner==false){
                    if (this.buywith=='SHUF'){
                        this.RaffleDapp.methods.BuyTicket(this.amnt).send({from: this.address}).once('transactionHash', (hash) => {
                        this.message = `You have purchased ${this.amnt} ticket${this.amnt>1?"s":""}! Good luck!`;
                        this.tx_hash = hash;
                        this.button_message="Return"; 
                        this.return_btn=true;
                        }).once('confirmation',  (confirmationNumber, receipt) =>{
                            if(receipt.blockNumber != this.last_tic_block){      
                                this.$root.$emit('ticket_interact', receipt);
                                    if(this.return_btn==false){
                                        this.load_store();
                                    } 
                                this.last_tic_block=receipt.blockNumber;    
                            }                    
                        }).on('error', (error) =>{console.error(error) });
                    }
                    else if(this.buywith=='ETH'){
                        let input = (new BigNumber(10**18)).times(this.amnt).times(this.ticketcost).times(100).dividedToIntegerBy(98);   
                        let output = new BigNumber(await this.unishuf.methods.getEthToTokenOutputPrice(input.toFixed()).call()); 
                        let total= output.times(1.006).dividedToIntegerBy(1);

                        this.RaffleDapp.methods.BuyTicketEth(this.amnt).send({from: this.address,value:total.toFixed()}).once('transactionHash', (hash) => {
                        this.message = `You have purchased ${this.amnt} ticket${this.amnt>1?"s":""}! Good luck!`;
                        this.tx_hash = hash;
                        this.button_message="Return"; 
                        this.return_btn=true;
                        }).once('confirmation',  (confirmationNumber, receipt) =>{
                            if(receipt.blockNumber != this.last_tic_block){      
                                this.$root.$emit('ticket_interact', receipt);
                                    if(this.return_btn==false){
                                        this.load_store();
                                    } 
                                this.last_tic_block=receipt.blockNumber;    
                            }                    
                        }).on('error', (error) =>{console.error(error) });

                    }
                    else{
                        if( this.mustApproveErc20==false){
                            let unitoken = getunitoken(readWeb32socket(),this.ERC20.exchange)
                            let input1 = (new BigNumber(10**18)).times(this.amnt).times(this.ticketcost).times(100).dividedToIntegerBy(98);  
                            let output1 = new BigNumber(await this.unishuf.methods.getEthToTokenOutputPrice(input1.toFixed()).call());
                            let output2 = new BigNumber(await unitoken.methods.getTokenToEthOutputPrice(output1.times(1.006).dividedToIntegerBy(1).toFixed()).call());
                            let total= output2.times(1.006).dividedToIntegerBy(1);

                            this.RaffleDapp.methods.BuyTicketUniswap(this.amnt,this.ERC20.address, total.toFixed()).send({from: this.address}).once('transactionHash', (hash) => {
                            this.message = `You have purchased ${this.amnt} ticket${this.amnt>1?"s":""}! Good luck!`;
                            this.tx_hash = hash;
                            this.button_message="Return"; 
                            this.return_btn=true;
                            }).once('confirmation',  (confirmationNumber, receipt) =>{
                                if(receipt.blockNumber != this.last_tic_block){      
                                    this.$root.$emit('ticket_interact', receipt);
                                        if(this.return_btn==false){
                                            this.load_store();
                                        } 
                                    this.last_tic_block=receipt.blockNumber;    
                                }                    
                            }).on('error', (error) =>{console.error(error) });
                        }
                        else{
                            this.approveErc20()
                        }
                    }
                }
                else{
                    this.message = `Too late! But you can always pick the winner!`
                    this.ready=false;
                    this.button_message="Pick the Winner"
                    this.mustload=false;
                }
        },

          approveErc20: async function(){
            const web3 = await getWeb3(true);
            const contract = geterc20contract(web3,this.ERC20.address);
            contract.methods.approve(this.RaffleDapp.address, "100000000000000000000000000").send({from: this.address}).once('transactionHash', (hash) => {
                this.ready = false;
                this.message = "Waiting for transaction to confirm...";
                this.tx_hash = hash;
            }).once('confirmation',  () =>{this.buy_button_message= "Buy now";this.ready = true;this.tx_hash=false;this.mustApproveErc20=false}).on('error', (err) =>{this.message = "Transaction error...";console.log(err) });
        },

        on_set_amnt: function(event) {
            this.amnt=event.srcElement.value;
            this.find_total();
            return true;
        },

        find_total:async function() {
            if(this.buywith=='SHUF'){
               this.totalcost=this.amnt*this.ticketcost;
            }
            else if(this.buywith=='ETH'){
                let input = (new BigNumber(10**18)).times(this.amnt).times(this.ticketcost).times(100).dividedToIntegerBy(98);   
                let output = new BigNumber(await this.unishuf.methods.getEthToTokenOutputPrice(input.toFixed()).call()); 
                this.totalcost = output.times(1.005).div(10**18).toFixed(3);
            }
            else{
                let unitoken = getunitoken(readWeb32socket(),this.ERC20.exchange)
                let input1 = (new BigNumber(10**18)).times(this.amnt).times(this.ticketcost).times(100).dividedToIntegerBy(98);  
                let output1 = new BigNumber(await this.unishuf.methods.getEthToTokenOutputPrice(input1.times(1.005).dividedToIntegerBy(1).toFixed()).call());
                let output2 = new BigNumber(await unitoken.methods.getTokenToEthOutputPrice(output1.times(1.005).dividedToIntegerBy(1).toFixed()).call());
                this.totalcost = output2.div(10**this.ERC20.decimals).toFixed(3);
            }
        return true;
        },


        get_wallet_balance:async function() {
            if(this.buywith=='SHUF'){
                const bal= await this.TokenContract.methods.balanceOf(this.address).call();
                this.wallet_balance = formatAmount(Math.floor(parseFloat(bal.toString()) / 10 ** 18));
            }
            else if(this.buywith=='ETH'){
                const web = readWeb32socket()
                const bal= new BigNumber(await web.eth.getBalance(this.address))
                this.wallet_balance = bal.div(10**18).toFixed(2);
            }
            else{
                const contract = geterc20contract(readWeb32(),this.ERC20.address)
                const bal= new BigNumber(await contract.methods.balanceOf(this.address).call())
                this.wallet_balance = bal.div(10**this.ERC20.decimals).toFixed(2);
                this.check_erc20_allowance(contract);
            }
        return true;
        },

                
        check_erc20_allowance:async function(contract){
            const Vallowance = await contract.methods.allowance(this.address,this.RaffleDapp.address).call();
            if(Vallowance<10**24){
                this.buy_button_message="Approve";
                this.mustApproveErc20=true;     
            }else{
                this.buy_button_message="Buy now";
                this.mustApproveErc20=false;
            }
        },


        
           

        load_wallet_approve_return_winner: function() {
            if (this.mustAprrove==true)
                this.approve();
            else if (this.mustPickWinner==true){
                if(this.mustsyncWF==true){
                    this.message="Please wait..."; 
                    this.return_btn=false;
                    this.tx_hash=false;
                    this.mustsyncWinFal();
                }
                else
                    this.pickWinner();}
            else if(this.return_btn==true){
                this.ready=false;
                if(this.mustsyncWF==true){
                    this.message="Please wait..."; 
                    this.return_btn=false;
                    this.tx_hash=false;
                    this.mustsyncWinFal();
                }
                else{
                    this.mustload=true; 
                    this.load_store();
                }
            }
            else{
                this.mustload=true;
                this.load_wallet();
            }       
        },

        load_wallet: async function() {
            try{
            if (this.ready==false)
                this.mustload=true;

            const web3 = await getWeb3(true);
            if (!web3) {
                this.message = "Ethereum wallet not found";
                this.button_message = "Reload wallet";
                this.button_class = "btn-warning";
                return;
            }

            const givenProvider = web3.eth;
            if (await promisify(givenProvider.getId, []) !== 1) { //3=ropsten
                this.message = "The Ethereum wallet must be set to Mainnet";
                this.button_message = "Reload wallet";
                this.button_class = "btn-warning";
            } else {
                const accounts = await promisify(web3.eth.getAccounts, []);
                if (!accounts || accounts.length === 0) {
                    return;
                }

                this.web3 = web3;
                this.TokenContract = getTokenContract(web3);
                this.RaffleDapp = getRaffleDapp(web3); 
                this.address = web3.utils.toChecksumAddress(accounts[0]);
                this.lastState= this.address.toLowerCase();
                this.loaded=true;
                window.web3.currentProvider.publicConfigStore.on('update', this.account_changed);
            }
            }catch(error) {
                 console.error(error);
            }
        
            this.check_allowance();
        },

        approve:  function(){
            this.TokenContract.methods.approve(this.RaffleDapp.address, "100000000000000000000000000").send({from: this.address}).once('transactionHash', (hash) => {
            this.message = "Waiting for transaction to confirm...";
            this.mustAprrove=false;
            this.mustload=false;
            this.tx_hash = hash;
            }).once('confirmation',  () =>{this.load_store();}).on('error', () =>{this.message = "Transaction error..." });
        
        },
 
        check_allowance:async function(){
            const Vallowance = await this.TokenContract.methods.allowance(this.address,this.RaffleDapp.address).call();
            if(Vallowance>10**24){
                this.mustAprrove=false;
                this.mustload=true;  
                this.load_store();
            }
            else{
                this.message="The Dapp must be approved first to buy a ticket.";
                this.button_message="Approve";
                this.ready=false;
                this.mustAprrove=true;     
            }
        },

        mustsyncWinFal:async function(){
            await this.load_price_mustPickWinner();
            if (this.mustPickWinner==false){
                this.mustsyncWF=false;
                clearTimeout(this.mustsyncWinFal_timeout);
                this.load_store();
            }
            else
                this.mustsyncWinFal_timeout =  setTimeout(this.mustsyncWinFal, 5000);
        },

        limbo: async function(){
            await this.load_price_mustPickWinner();
            if (this.mustPickWinner===true){
                this.load_store();
            } 
        },
        
        load_store: async function(){
            this.amnt=1;   
            await this.load_price_mustPickWinner();   
            this.tx_hash=false;
            this.return_btn=false;
            this.mustAprrove=false;
            this.MPWP = false;
            this.subscribe_winner();
            if(this.mustPickWinner==true){
                this.subscribe_closed(); 
                if(this.raffleClosed == false){
                    this.ready=false;
                    this.message=`Get rewarded ${this.pickerreward} SHUF to close the raffle!`;
                    this.button_message="Close the Raffle"
                    this.mustload=false;     
                }
                else{
                    this.ready=false;
                    this.message=`Get rewarded ${this.pickerreward} SHUF to pick the winner!`;
                    this.button_message="Pick the Winner"
                    this.mustload=false;   
                }    
            }
            else{ 
                this.mustload=false;
                this.ready=true;
                this.message="Ticket Store";   
                await this.load_tickets(this.address);
                this.get_wallet_balance();
                this.find_chances();
            }
        },

        load_price_mustPickWinner: async function(){ 
            const Stats = await this.RaffleDapp.methods.Stats().call();
            this.pickerreward= formatAmount(parseFloat(Stats[6].toString()) / 10 ** 18);
            this.ticketcost = formatAmount(parseFloat(Stats[4].toString()) / 10 ** 18,10);
            this.preserve = Stats[12];
            this.mustPickWinner = Stats[5];
            this.raffleClosed = Stats[11];
            this.find_total();
        },
    
        load_tickets: async function(){
            this.ticketsowned  = await this.RaffleDapp.methods.TicketsOfAddress(this.address).call();
            let Stats = await this.RaffleDapp.methods.Stats().call();
            this.totaltickets = Stats[1].toString();
        },

        find_chances: async function(){
            this.chances=(this.totaltickets>0)?((parseFloat(this.ticketsowned)/parseFloat(this.totaltickets))*100).toFixed(2).toString():'0';
        },

        pickWinner: async function(){ 
            this.RaffleDapp.methods.pickWinner().send({from: this.address}).once('transactionHash', (hash) => {
            if(this.raffleClosed==false){
                this.message = `Please wait while closing the Raffle...`;
                this.raffleClosed= true;
                this.tx_hash = hash;
                this.MPWP = true;
            }
            else{
                this.message = `Please wait while picking the Winner...`;
                this.tx_hash = hash;
                this.MPWP = true;
                }
            })
        },

        shortAddressR:  function  (addr){
            return `${addr.slice(0, 5)}. . .${addr.slice(-5)}`;
        }
    }
}

function compare(a, b) {
  // Use toUpperCase() to ignore character casing
  const symbolA = a.symbol.toUpperCase();
  const symbolB = b.symbol.toUpperCase();

  let comparison = 0;
  if (symbolA > symbolB) {
    comparison = 1;
  } else if (symbolA < symbolB) {
    comparison = -1;
  }
  return comparison;
}

function shortAddress (addr){
    return `${addr.slice(0, 5)}. . .${addr.slice(-5)}`;
    }

function formatAmount(amount, maxDigits = 6)  {
    if (amount.toString().length <= maxDigits) {
        return amount.toString();
    }
    const intDigits = amount.toFixed(0).toString().length;
    const decDigits = maxDigits - intDigits;
    const decimals = (decDigits > 0) ? decDigits : 0;
    return Number(amount.toFixed(decimals)).toString();
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>

<style scoped>

.tokenrow{
    flex: 0 1 750px; 
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items:center;
    align-content: center; 
}
.erc20button{
    min-width: 150px;
    margin-right: 20px;
    margin-left: 20px;
    margin-top:5px;
    margin-bottom:5px;
    flex: 0 1 150px; 
    
    font-weight: 500;
    font-size: 19px;
    min-width: 150px;
     box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;

}
.token_text{
    
    font-size: 19px;
    letter-spacing: 0.03em;  
    text-align: -webkit-center;
    text-align: center ;
    line-height: 93.19%;
    width:100%;
    color: #FFFFFF; 
}
.token-button {
    
      margin-top:5px;
    margin-bottom:5px;
    justify-content: center!important;
    min-width: 150px;
    margin-right: 20px;
    margin-left: 20px;
    position: relative;
    text-align: center;
    display: flex;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    font-weight: 500;
    font-size: 19px;
    line-height: 93.19%;
    padding: 10px;
}
.icon{
    width:40px;
    height:40px;
    margin-left:10px;
}
.my-row{
    max-width: 750px;;
    margin:auto;
    margin-top:15px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    align-content: center;
}
.flex11{
    flex: 0 1 750px; 
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: baseline;
    align-content: center; 
}
.buy_text{
    font-size: 25px !important; 
    margin-bottom:20px;
    margin-top:30px;
}
.mini_text{
    font-size: 15px !important;
    margin-bottom:30px;
}
.flex12{
    flex: 0 1 320px; 
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center; 
}
.flex22{
    flex: 1 1 160px;
    padding: 0 5px 0 5px;
    display: flex;
    margin: 17px auto 17px auto;
    flex-flow: row wrap;
}
.ticketbox{
    flex: 0 1 750px; 
    max-width: 750px;
    margin:auto;
    margin-top:20px;
    padding: 13px 30px 13px 30px; 
    background: #286323;
    box-shadow: 1px 1px 4px 1.5px #111111 inset;
    border-radius: 12px;
    display: block; 
    width: auto;
    text-align: left;
    z-index: 32;
}
.main{
    align-self: center;
    padding: 0 60px;
}
.form-control{
    display: inline-block;
    text-align: center;
    font-size: 35px;
    border-radius: 0px;
    background: transparent;
	margin: 0px 10px 0px 10px;
	color: #fff;
	width: 80px;
    height: 1.3em;
	border-top: 2px transparent;
	border-left: 2px transparent;
	border-right: 2px transparent;
	border-bottom: 2px solid;
	border-color: #FFFFFF;
	outline: none;
	padding: 0px 0px 0px 0px ;   
    text-shadow: 4px 4px 3px #000000;
}
.form-control:focus {
    background: transparent;
    color: #FFFFFF;
	border-color: #AF2020 !important;
    -webkit-box-shadow: none;
    box-shadow: none;
}
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
}
.message{
    display: inline-block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: auto;
}
.join-button {
    margin-right: auto;
    margin-left: auto;
    position: relative;
    text-align: center;
    display: flex;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    font-weight: 500;
    font-size: 19px;
    line-height: 93.19%;
    padding: 10px;
}

.margin-top{
    margin-top:20px; 
}
.red-red{
    border-color: #AF2020;
    background-color: #AF2020;
}
.background{
    display:flex;
    justify-content: center;
    min-height: 201px;
    position: static;
    width: 100%;
    padding: 50px 0px;
    background: linear-gradient(181.07deg, #21540F 9.11%, #153413 83.74%), #153312;
}
.store_text{
    font-size: 19px;
    letter-spacing: 0.03em;  
    text-align: -webkit-center;
    text-align: left;
    line-height: 93.19%;
    width:100%;
    color: #FFFFFF; 
}

h2{
    position: static;
    width: 431px;
    text-align: -webkit-center;
    font-weight: 500;
    font-size: 35px;
    text-align: left;
    line-height: 93.19%;
    padding: 5px; 
    margin: auto;
    display: flex;
    letter-spacing: -0.02em;
    color: #FFFFFF;
}

@media screen and (max-width: 767px) {
    .main{
       padding-left:40px !important;
       padding-right:40px !important; 
    }
    .background{
        padding: 50px 2%
    }
}

@media screen and (max-width: 950px) {
    .flex22{
        justify-content: center!important;
        text-align: center !important;
        flex-basis: 270px;
    }
    .flex12{
        flex: 1 1 900px;
    }
    .flex221{
        margin: 15px auto 5px auto;
    }
    .flex222{
        margin: 5px auto 15px auto;
    }
    .flex11{
        justify-content: center!important;
        text-align: center !important;
        flex-basis: 950px;
    }
}

</style>
